import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, Image, Text } from 'rebass';
import Helmet from 'react-helmet';
import {
  display,
  flexDirection,
  justifyContent,
  alignItems,
  height,
  overflow,
} from 'styled-system';
import styled, { createGlobalStyle } from 'styled-components';

import { CenterContentTemplate } from '@oca/ui';
import { i18n } from '@lib/i18n';

import { getOrganizationMeta } from '../lib/get-meta';

const ORG = process.env.REACT_APP_ORGANIZATION;

export function AuthPageTemplate({ heading, children, title }) {
  const meta = getOrganizationMeta(ORG);
  const { logo: Logo, favicon } = meta;
  const defaultTitle = i18n._(meta.title);
  // const fullName = i18n._(meta.fullName);

  return (
    <CenterContentTemplate>
      <Helmet defaultTitle={defaultTitle} titleTemplate={meta.titleTemplate}>
        {title && <title>{title}</title>}
        {favicon && <link rel="icon" href={favicon} />}
      </Helmet>
      <GlobalStyles />
      <FlexCard
        width="800px"
        boxShadow={1}
        bg="white"
        borderRadius={12}
        overflow="hidden"
      >
        <Box width={2 / 5} px={4} pt={5} pb={3}>
          {heading}
          {children}
        </Box>
        <Box width={3 / 5} backgroundColor="white">
          <FlexCard
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <FlexCard
              alignItems="center"
              justifyContent="center"
              marginBottom={2}
              marginX="auto"
            >
              <Image
                marginX="auto"
                width="70%"
                height="70%"
                src="/logo/logo-text.svg"
              />
            </FlexCard>
          </FlexCard>
        </Box>
      </FlexCard>
    </CenterContentTemplate>
  );
}

AuthPageTemplate.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  title: PropTypes.string,
};

AuthPageTemplate.defaultProps = {
  children: null,
  title: null,
  heading: null,
};

const GlobalStyles = createGlobalStyle`
  #root { 
    background: white;
  }
`;

const FlexCard = styled(Card)`
  ${display};
  ${flexDirection}
  ${justifyContent};
  ${alignItems};
  ${height};
  ${overflow};
`;

FlexCard.defaultProps = {
  display: 'flex',
};

// eslint-disable-next-line react/prop-types
const HeroBlock = ({ width, children, bgImage }) => (
  <FlexCard
    display="block"
    width={width}
    backgroundImage={`url(${bgImage})`}
    backgroundRepeat="no-repeat"
    backgroundSize="cover"
  >
    {children}
  </FlexCard>
);
